var map = {
	"./change_background.gif": 8989,
	"./change_pose.gif": 6282,
	"./change_style.gif": 1348,
	"./create.gif": 9750,
	"./remove_background.gif": 3037,
	"./text_to_image.gif": 6571,
	"./video_animate.gif": 7519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9041;